export const projectMaterials = {
  onboardingSteps: [
    {
      key: 'title_brief',
      status: 'empty',
      name: 'Title + Brief',
      type: 'single',
      hero: 'General Overview/Project Brief',
      description:
        'Tell us about your project or upload your existing brief and branding guidelines. A brief is simply a single document that describes the requirements of your video. If you already have one, great! Upload it and move on to the next step. If not, just write out what you want us to create for you.',
      project_name: '',
      project_brief: '',
      profile_picture: '',
      attachments: [],
      selectedValue: [],
      cards: [
        {
          isSpecial: true,
          value: 'project_brief',
        },
      ],
    },
    {
      key: 'script',
      status: 'empty',
      name: 'Script',
      type: 'single',
      hero: 'Does your video require a script or subtitles?',
      description:
        'If your video requires either a script to be read out loud by a voiceover actor or have text on screen (subtitles, text animations, etc.), let us know.',
      selectedValue: [],
      cards: [
        {
          label: 'No',
          text: '',
          value: 'no',
          noIcon: true,
        },
        {
          label: 'Yes, I will provide a final version.',
          text: '',
          value: 'final_version',
          noIcon: true,
        },
        {
          label: 'Yes, but I need help creating.',
          is_hand: true,
          text: '',
          value: 'help_creating',
          noIcon: true,
        },
        {
          label: "I don't know and need help.",
          is_hand: true,
          text: '',
          value: 'dont_know',
          noIcon: true,
        },
      ],
    },
    {
      key: 'storyboard',
      name: 'Storyboard',
      status: 'empty',
      type: 'single',
      hero: 'Does this project require a storyboard?',
      description:
        'A storyboard is a series of sketches depicting important changes of scene and action in your video. More complex projects often require a visual storyboard, particularly for animations or production shoots. ',
      selectedValue: [],
      cards: [
        {
          label: 'No',
          text: '',
          value: 'no',
          noIcon: true,
        },
        {
          label: 'Yes, I will provide a final version.',
          text: '',
          value: 'final_version',
          noIcon: true,
        },
        {
          label: 'Yes, but I need help creating.',
          is_hand: true,
          text: '',
          value: 'help_creating',
          noIcon: true,
        },
        {
          label: "I don't know and need help.",
          is_hand: true,
          text: '',
          value: 'dont_know',
          noIcon: true,
        },
      ],
    },
    {
      key: 'soundtrack',
      status: 'empty',
      name: 'Soundtrack',
      type: 'multi',
      number_of_sections: 2,
      current_section: 0,
      selectedValue: [],
      cards: [
        {
          hero: 'Does this project require a soundtrack?',
          description:
            'Almost all videos need background music, what are your requirements?',
          type: 'single',
          inner_cards: [
            {
              label: 'No',
              text: '',
              value: 'no',
              noIcon: true,
            },
            {
              label: 'Yes, I will provide the final track(s) to use.',
              text: '',
              value: 'final_track',
              noIcon: true,
            },
            {
              label: 'Yes, but I need help choosing.',
              is_hand: true,
              text: '',
              value: 'help_choosing',
              noIcon: true,
            },
            {
              label: "I don't know and need help.",
              is_hand: true,
              text: '',
              value: 'dont_know',
              noIcon: true,
            },
          ],
        },
        {
          hero: 'What type of soundtrack will you need for your video?',
          description: 'Select the best fit',
          max_responses: 2,
          inner_cards: [
            {
              label: 'Vocals',
              text: '(covers)',
              value: 'vocals',
            },
            {
              label: 'Electronic',
              text: '(upbeat funk)',
              value: 'electronic',
            },
            {
              label: "Rock n'Roll",
              text: '(throwback tracks)',
              value: 'rock_n_roll',
            },
            {
              label: 'Classic',
              text: '(cinematic documentaries)',
              value: 'classic',
            },

            {
              label: 'Dramatic',
              text: '(for fast action scenes)',
              value: 'dramatic',
            },
            {
              label: 'Other',
              text: '',
              value: 'other',
              containInput: true,
              placeholder: 'Add your own category...',
            },
            {
              label: "I don't know",
              text:
                'Select this for any questions you’re unsure about and our creative services team will help you out!',
              value: 'dont_know',
              is_hand: true,
            },
          ],
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/overviewSteps/projectMaterials.js